import { render, staticRenderFns } from "./TermsofUse.vue?vue&type=template&id=729b7975&scoped=true"
import script from "./TermsofUse.vue?vue&type=script&lang=js"
export * from "./TermsofUse.vue?vue&type=script&lang=js"
import style0 from "./TermsofUse.vue?vue&type=style&index=0&id=729b7975&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "729b7975",
  null
  
)

export default component.exports